import React from "react"
import About from "../pages/About"
import Blog from "../pages/Blog"
import BlogPost from "../pages/BlogPost"
import Dashboard from "../pages/Dashboard"
import UserDashboard from "../pages/UserDashboard"
import Home from "../pages/Home"
import Login from "../pages/Login"
import Projects from "../pages/Projects"
import ProjectDetails from "../pages/ProjectDetails"
import AdminProjectCreate from "../pages/AdminProjectCreate"
import AdminProjectEdit from "../pages/AdminProjectEdit"
import AdminPostCreate from "../pages/AdminPostCreate"
import AdminPostEdit from "../pages/AdminPostEdit"
import Signup from "../pages/Signup"
export const navItems = [
    {   path: '/',          name: 'Home',       element: <Home />,      isMenu: true,   isPrivate: false },
    {   path: '/dashboard', name: 'Dashboard',  element: <UserDashboard/>,  isMenu: true,   isPrivate: true },
    {   path: '/admin/dashboard', name: 'Admin',  element: <Dashboard/>,  isMenu: false,   isPrivate: true },
    {   path: '/about',     name: 'About',      element: <About />,     isMenu: true,   isPrivate: false },
    {   path: '/blog',      name: 'Blog',       element: <Blog />,      isMenu: false,  isPrivate: false },
    {   path: '/blog/:slug', name: 'Blog Post', element: <BlogPost />, isMenu: false, isPrivate: false },
    {   path: '/projects',  name: 'Projects',   element: <Projects />,  isMenu: true,   isPrivate: false },
    {   path: '/projects/:slug', name: 'Project Details', element: <ProjectDetails/>, isMenu: false, isPrivate: false },
    {   path: '/admin/projects/new', name: 'New Project', element: <AdminProjectCreate />, isMenu: false, isPrivate: true },
    {   path: '/admin/projects/:id/edit', name: 'Edit Project', element: <AdminProjectEdit />, isMenu: false, isPrivate: true },
    {   path: '/admin/posts/new', name: 'New Post', element: <AdminPostCreate />, isMenu: false, isPrivate: true },
    {   path: '/admin/posts/:id/edit', name: 'Edit Post', element: <AdminPostEdit />, isMenu: false, isPrivate: true },
    {   path: '/login',     name: 'Login',      element: <Login/>,      isMenu: false,  isPrivate: false },
    {   path: '/signup',    name: 'SIGNUP',     element: <Signup/>,     isMenu: false,  isPrivate: false },
];